// React Lib
import React, { useState, useEffect } from "react";
// Component Styles
import { useStyles } from "./DrawerStyles";
// @otg-one/ui_components/components
import { Typography, Tooltip } from "../index";
// @otg-one/ui_components/constants
import { FONT_FAMILY, Color } from "../../constants";
export const Drawer = (props) => {
    const classes = useStyles(props);
    const [activeMenu, setActiveMenu] = useState({});
    const { id, activeOption, isProcessTypeAlreadyAddedToCollection, collection, menus, isScrolling, setIsScrolling, setAppPreviewNavIndex, style, toolTipTitle } = props;
    useEffect(() => {
        if (activeOption !== `` && !isScrolling) {
            menus.forEach(menu => {
                if (menu.name === activeOption) {
                    setActiveMenu(menu);
                    setAppPreviewNavIndex(0);
                }
            });
        }
    }, [activeOption]);
    const handleMenuOnClick = (menu) => () => {
        setIsScrolling(true);
        setActiveMenu(menu);
        setAppPreviewNavIndex(0);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { style: Object.assign({ width: "100%" }, style), id: id }, menus.map((menu, index) => (React.createElement("div", { key: `menu${index}`, className: classes.drawerMenu }, menu.name !== "" && (React.createElement(React.Fragment, null,
            React.createElement("a", { style: {
                    textDecoration: "none"
                }, href: `#${menu.name}` },
                React.createElement("div", { className: classes.drawerMenuLabel, onClick: handleMenuOnClick(menu) },
                    React.createElement(Typography, { fontFamily: menu.name === activeMenu.name ? FONT_FAMILY.ROBOTO_BOLD : FONT_FAMILY.ROBOTO_REGULAR, size: 16, color: menu.name === activeMenu.name ? Color.neutral[900] : Color.neutral[400], style: { marginLeft: 8 } }, menu.name))),
            React.createElement(React.Fragment, null, isProcessTypeAlreadyAddedToCollection(collection, menu) && (React.createElement(Tooltip, { title: toolTipTitle, placement: "right" },
                React.createElement("div", { className: classes.drawerMenuIsCustomizedTag })))))))))),
        React.createElement("a", { id: "link-drawer", style: { visibility: "hidden" } })));
};
Drawer.defaultProps = {
    menus: [
        {
            name: 'Menu 1'
        },
        {
            name: 'Menu 2'
        },
    ],
    isProcessTypeAlreadyAddedToCollection(collection, menu) {
        return null;
    },
    toolTipTitle: "Added to Collection"
};
export default React.memo(Drawer);
